define('viewmodels/Calculations/CustomWReport',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger', 'services/utils'], function (ko, router, appsecurity, navigation, app, system, logger, utils) {

    var CRmViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        utils: utils,
        ClickUploaddocument: ClickUploaddocument,
        popUpTitle: ko.observable(),
        EditUserDetails: ko.observable(true),
        getoptions: getoptions,
        DocumentTypeList: ko.observableArray(),
        DocumentTypeListDup: ko.observableArray(),
        ControlsAccess: ko.observable(false),
        addPopUpCss: ko.observable(),
        valuedoctype: ko.observable(),
        FolderName: ko.observable(),
        UploadDocument: UploadDocument,
        comments: ko.observable(),
        UploadReportDetails: UploadReportDetails,
        YearofAssessment: ko.observable(),
        YearChanged: YearChanged,
        docpath: ko.observable(),
        ReportDetailsList: ko.observableArray(),
        EditReportPopUp: EditReportPopUp,
        EditDocumentDetails: ko.observableArray(),
        LowestOptionSprocList: ko.observableArray(),
        LowestOptionList: ko.observableArray(),
        Optionvaluedoctype: ko.observable(),
        CurrentYear: ko.observable(),
        ReportModelCount: ko.observable(0),
        DownloadReport: DownloadReport,
        DeleteReportPopUp: DeleteReportPopUp,
        Savedisabled: ko.observable(true),
        UploadFileSize: ko.observable(3145728),
        CurrentProfile: ko.observable(),
        SaveDocument: SaveDocument,
        //YearofAssessmentList: ko.observableArray(),
        ProfileofAssessmentList: ko.observableArray(),
        SrNo: ko.observable(0),
        DocPath: ko.observable(""),
        UploadWordDocument: UploadWordDocument,
        NavigateToSSRSProcessReport: NavigateToSSRSProcessReport,
        DownloadArchiveReport: DownloadArchiveReport,
        DownloadErrorReport: DownloadErrorReport,
        Refresh: Refresh,
    };
    return CRmViewModel;

    var UserTableObj = false;



    function activate() {
        try {
            CRmViewModel.DocPath("");
            // CRmViewModel.EditDocumentDetails(new WordReportDetailsModel({ DocumentType: '', DocumentUploadedforYear: '', DocumentComments: "", DocumentPath: "" }));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            CRmViewModel.DocPath = "";
            if (appsecurity.WriteAccess()) {
                CRmViewModel.ControlsAccess(true);
            }
            else {
                CRmViewModel.ControlsAccess(false);
            }
            //   getProfileOfAssessmentDetails();
            //  getoptions();

            getReportDetails();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function DownloadReport(data, event) {
        try {
            for (var i = 0; i < CRmViewModel.ProfileofAssessmentList().length; i++) {
                if (data.DocumentUploadedforProfile() == CRmViewModel.ProfileofAssessmentList()[i].Profilename()) {
                    var Profile = CRmViewModel.ProfileofAssessmentList()[i].ProfileId();
                    break;
                }

            }
            for (var i = 0; i < CRmViewModel.DocumentTypeList().length; i++) {
                if (data.DocType() == CRmViewModel.DocumentTypeList()[i].DocCode()) {
                    var DocType = CRmViewModel.DocumentTypeList()[i].DocType();
                    break;
                }

            }
            var payLoad = {
                t: appsecurity.getAuthenticationInfo(), FilePath: data.DocPath().substring(data.DocPath().lastIndexOf('}'), 0), Profile: Profile, DocType: DocType, FileName: data.DocumentName()
            };
            utils.postAndRedirect(rootPath + "/FileDownload/DownloadReportFile", payLoad, '_blank');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadReport() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function YearChanged(data, event) {
        try {
            if (event.target.value.length == 4 && !isNaN(event.target.value) && event.target.value.indexOf(' ') == -1) {
                document.getElementById("valfactorerror").innerHTML = "";
                $(valfactorerror).hide();
                CRmViewModel.Savedisabled(true);
            }
            else {
                $(valfactorerror).show();

                document.getElementById("valfactorerror").innerHTML = "Please enter valid Year of Assessment";
                CRmViewModel.Savedisabled(false);
            }
            //getleveloptions();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: YearChanged() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function getReportDetails() {
        try {
            $('#loadingCommentsImg').show();
            $('#tb1').hide();
            try {

                $.ajax({
                    url: "/api/Calculation/GetWordReportDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getReportDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    $('#loadingCommentsImg').hide();
                    CRmViewModel.SrNo(0);

                    if (jsonResult.length == 0) {
                        logger.logError('No records present.', 'Warning', system.getModuleId(CRmViewModel), true);
                        $('#tb1').hide();
                    }
                    else if (jsonResult != null) {

                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null)
                        {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CRmViewModel), true);
                        }
                        else
                        {
                            CRmViewModel.SrNo(0);
                            $('#tb1').show();
                            var mappedUserDetails = $.map(jsonResult, function (result) {
                                return new WordReportDetailsModel(result);
                            });

                            QuestionTableObj = undefined;
                            tableObj = $('#tblReportDetails').DataTable();
                            tableObj.destroy();
                            $('#tblReportDetails tbody tr').remove();
                            CRmViewModel.ReportDetailsList([]);
                            CRmViewModel.ReportDetailsList(mappedUserDetails);
                            QuestionTableObj = $('#tblReportDetails').DataTable({
                                "aoColumnDefs": [{
                                    "bSortable": false
                                }],
                                "order": [[0, "desc"]]
                            });
                            $('#tblReportDetails').DataTable();
                        }
                    }
                    else
                        logger.logError('Some Error Occured while Fetching Active Roles', 'Error', system.getModuleId(CRmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getReportDetails() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function getProfileOfAssessmentDetails() {
        try {

            $.ajax({
                url: "/api/Calculation/GetProfileAssessmentData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getProfileOfAssessmentDetails() method in ReportManagement.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null)
                {
                if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                    logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CRmViewModel), true);
                }

                    if (jsonResult.length > 0) {
                        var MappedYearofAssessment = $.map(jsonResult, function (result) {
                            return new ProfileofAssessmentModel(result);
                        });
                        CRmViewModel.ProfileofAssessmentList([]);
                        CRmViewModel.ProfileofAssessmentList(MappedYearofAssessment);
                    }
                }
                else
                    logger.logError('An error occurred while fetching the Assessment Profiles. Please contact your application administrator.', 'Error', system.getModuleId(CRmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from getProfileOfAssessmentDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                var msg = 'Exception: ' + error + ' | Source: ajaxSuccess from getProfileOfAssessmentDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from getProfileOfAssessmentDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

    }

    function ClickUploaddocument() {
        try {
            var NewDataObj = new ReportDetailsModel({ DocumentType: CRmViewModel.valuedoctype(), DocumentUploadedforYear: CRmViewModel.CurrentYear(), DocumentComments: "", DocumentPath: "" });
            CRmViewModel.LowestOptionList([]);
            CRmViewModel.LowestOptionSprocList([]);
            CRmViewModel.DocumentTypeList([]);
            CRmViewModel.DocumentTypeList(CRmViewModel.DocumentTypeListDup())
            CRmViewModel.EditDocumentDetails(NewDataObj);
            CRmViewModel.popUpTitle("Upload Document");
            CRmViewModel.addPopUpCss(true);
            $('#adddoc').modal('show');
            $('#modalContent').css({
                'margin-top': '25%'
            });
            setTimeout("$('#yearinput').focus();", 200);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClickUploaddocument() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function UploadWordDocument() {

        try {
            var FileList = document.getElementById('FileUploader').files;
            if (FileList.length > 0) {
                var FileName = document.getElementById('FileUploader').files[0].name;
                if ((FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase()) == 'TXT' && FileName.substring(0, FileName.lastIndexOf('.')) == "DERA Data File") {
                    if (FileList[0].size <= 3145728) {

                        document.getElementById('valfactorerror').innerHTML = "";

                        var FormDataObj = new FormData();
                        FormDataObj.append("File1", FileList[0]);
                        var request = new XMLHttpRequest();

                        request.onreadystatechange = function () {
                            if (request.readyState == 1) {
                                document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                $('#valfactorerror').show();
                            }
                            else if (request.readyState == 4) {
                                if (request.status == 200) {
                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null" && request.responseText !== 0) {
                                        document.getElementById('valfactorerror').innerHTML = "File has been uploaded successfully.";
                                        $('#valfactorerror').show();
                                        UploadReportDetails(JSON.parse(request.response));
                                        var DocName = document.getElementById('FileUploader').files[0].name;
                                        document.getElementById('FileUploader').value = null;
                                        // SetComments(data.QuestionId(), "RD", "", DocName, JSON.parse(request.response), SrViewModel.UploadComment());
                                        Refresh();
                                        $('#valfactorerror').hide();
                                        $('#adddoc').modal('hide');
                                        $('body').removeClass('modal-open');
                                        $('.modal-backdrop').remove();
                                    }
                                    else {
                                        document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                        $('#valfactorerror').show();
                                        document.getElementById('FileUploader').value = null;
                                    }
                                }
                                else
                                    ajaxFail(request, "");
                            }
                        };
                        request.upload.addEventListener('progress', function (event) {
                            //SrViewModel.ProgressPercent(parseInt((event.loaded / event.total) * 100) + '%');
                            //SrViewModel.ProgressMessage("Uploading File...");
                            document.getElementById('valfactorerror').innerHTML = "Uploading file...";

                        });
                        request.withCredentials = true;

                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        request.open('POST', '/api/Survey/ImportQuantConfiguration');
                        request.setRequestHeader('Authorization', headers.Authorization);
                        request.setRequestHeader('RT', headers.RT);
                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                        request.send(FormDataObj);

                    }
                    else {
                        document.getElementById('valfactorerror').innerHTML = "Upload file size cannot exceed " + (CRmViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.";
                        $('#valfactorerror').show();
                    }
                }
                else {
                    document.getElementById('valfactorerror').innerHTML = "Please select valid file to upload";
                    $('#valfactorerror').show();
                }
            }
            else {
                document.getElementById('valfactorerror').innerHTML = "Please select a file to upload";
                $('#valfactorerror').show();
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {

                                }
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocument() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocument() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in ReportManagement.js';
            logger.logMessage(msg);
        }

    }


    function Refresh() {
        try {
            getReportDetails();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Refresh() method in SurveyResponse.js';
            logger.logMessage(msg);
        }
    }

    function SaveDocument() {
        try {
            if (CRmViewModel.EditDocumentDetails().DocComments() == undefined) {
                document.getElementById('valfactorerror').innerHTML = "Please enter comments.";
            }
            else {
                UploadDocument();
            }


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveDocument() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function getoptions() {
        try {
            try {
                $.ajax({
                    url: "/api/Calculation/Getdoctype",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getoptions() method in ReportManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {

                    if (jsonResult != null)
                    {
                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CRmViewModel), true);
                        }

                        else
                        {
                            var mappedUserDetails = $.map(jsonResult, function (result) {
                                return new Doctypes(result);
                            });
                            CRmViewModel.DocumentTypeList(mappedUserDetails);
                            CRmViewModel.DocumentTypeListDup(mappedUserDetails);
                        }
                    }

                    else
                        logger.logError('Some Error Occured while Fetching options', 'Error', system.getModuleId(CRmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetActiveRoles() method in UserRole.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getoptions() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getoptions() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getoptions() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function EditReportPopUp(data, event) {
        try {
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditReportPopUp() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function deleteReport(data) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/DeleteReport?DocId=" + data.DocId(),
                headers: headers,
                type: "POST"

            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteReport() method in ReportManagement.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult != null) {
                    if (jsonResult == 1) {
                        logger.logSuccess('Report Deleted sucessfully.', 'Success', system.getModuleId(CRmViewModel), true);
                        getReportDetails();
                    }
                    else {
                        logger.logError('Some Error Occured while Deleting Report', 'Error', system.getModuleId(CRmViewModel), true);
                    }
                }
                else
                    logger.logError('Some Error Occured while Deleting Report', 'Error', system.getModuleId(CRmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteReport() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteReport() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteReport() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        };

    }

    function DeleteReportPopUp(data, event) {
        try {
            try {
                app.showMessage('Are you sure you want to delete this Report?', 'Delete Report', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteReport(data, event);
                        }
                    });

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteReportPopUp() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DeleteReportPopUp() method in ReportManagement.js';
            logger.logMessage(msg);
        }


    }




    //file upload functionality
    function UploadDocument(data, event) {
        try {
            var FileList = document.getElementById('FileUploader').files;
            if (FileList.length > 0) {
                var FileName = document.getElementById('FileUploader').files[0].name;
                if ((FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PNG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'JPG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                        FileName.length).toUpperCase() == 'JPEG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                            FileName.length).toUpperCase() == 'DOCX' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                FileName.length).toUpperCase() == 'DOC' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                    FileName.length).toUpperCase() == 'XLS' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                        FileName.length).toUpperCase() == 'PDF' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                            FileName.length).toUpperCase() == 'XLSX' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                FileName.length).toUpperCase() == 'CSV' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                    FileName.length).toUpperCase() == 'TXT' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                        FileName.length).toUpperCase() == 'PPT' | FileName.substring(FileName.lastIndexOf('.') + 1,
                                                            FileName.length).toUpperCase() == 'PPTX') && (FileName.split('.').length - 1) == 1) {
                    if (FileList[0].size <= 3145728) {

                        document.getElementById('valfactorerror').innerHTML = "";

                        var FormDataObj = new FormData();
                        FormDataObj.append("File1", FileList[0]);
                        var request = new XMLHttpRequest();

                        request.onreadystatechange = function () {
                            if (request.readyState == 1) {
                                document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                $('#valfactorerror').show();
                            }
                            else if (request.readyState == 4) {
                                if (request.status == 200) {
                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                        document.getElementById('valfactorerror').innerHTML = "File has been uploaded successfully.";
                                        $('#valfactorerror').show();
                                        UploadReportDetails(JSON.parse(request.response));
                                        var DocName = document.getElementById('FileUploader').files[0].name;
                                        document.getElementById('FileUploader').value = null;
                                        // SetComments(data.QuestionId(), "RD", "", DocName, JSON.parse(request.response), SrViewModel.UploadComment());
                                        $('#adddoc').modal('hide');
                                        $('body').removeClass('modal-open');
                                        $('.modal-backdrop').remove();
                                    }
                                    else {
                                        document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                        $('#valfactorerror').show();
                                        document.getElementById('FileUploader').value = null;
                                    }
                                }
                                else
                                    ajaxFail(request, "");
                            }
                        };
                        request.upload.addEventListener('progress', function (event) {
                            //SrViewModel.ProgressPercent(parseInt((event.loaded / event.total) * 100) + '%');
                            //SrViewModel.ProgressMessage("Uploading File...");
                            document.getElementById('valfactorerror').innerHTML = "Uploading File...";

                        });
                        request.withCredentials = true;
                        for (var i = 0; i < CRmViewModel.DocumentTypeList().length; i++) {
                            if (CRmViewModel.DocumentTypeList()[i].DocCode() == CRmViewModel.valuedoctype()) {
                                CRmViewModel.FolderName(CRmViewModel.DocumentTypeList()[i].DocType());
                                break;
                            }
                        }
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        request.open('POST', '/api/Calculation/FileUpload?profileofassessment=' + CRmViewModel.CurrentProfile() + "&Doctype=" + CRmViewModel.FolderName());
                        request.setRequestHeader('Authorization', headers.Authorization);
                        request.setRequestHeader('RT', headers.RT);
                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                        request.send(FormDataObj);

                    }
                    else {
                        document.getElementById('valfactorerror').innerHTML = "Upload file size cannot exceed " + (CRmViewModel.UploadFileSize() / 1048576) + " MB. Please try uploading a file of lesser size.";
                        $('#valfactorerror').show();
                    }
                }
                else {
                    document.getElementById('valfactorerror').innerHTML = "Please select valid file to upload";
                    $('#valfactorerror').show();
                }
            }
            else {
                document.getElementById('valfactorerror').innerHTML = "Please select a file to upload";
                $('#valfactorerror').show();
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {

                                }
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocument() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocument() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in ReportManagement.js';
            logger.logMessage(msg);
        }

    }

    function UploadReportDetails(docpath) {
        try {
            var DocumnentName = docpath.substring(docpath.lastIndexOf('}') + 1, docpath.length)
            // CRmViewModel.EditDocumentDetails().DocPath(docpath)
            CRmViewModel.docpath(docpath);
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Calculation/UploadReportDetails?profile=" + CRmViewModel.CurrentProfile() + "&docname=" + DocumnentName + "&docpath=" + CRmViewModel.docpath() + "&type=" + $("#AmlDrpDwn option:selected").val() + "&comments=" + CRmViewModel.EditDocumentDetails().DocComments(),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in UploadReportDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult == 1) {
                            logger.logSuccess('Report Uploaded Successfully.', 'Success', system.getModuleId(CRmViewModel), true);
                            getReportDetails();

                        }
                    }
                    else
                        logger.logError('Some Error Occured while Uploading Report', 'Error', system.getModuleId(CRmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UploadReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UploadReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UploadReportDetails() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }
    //file upload functionality ends



    function NavigateToSSRSProcessReport(data) {
        try {
            $('#divProcessReport').html('');
            var homeurl = homeUrlLocation;
            var url = window.location.pathname;
            $('<iframe>', {
                src: homeurl + 'SSRSProcessReport.aspx?SurveyType=' + data.JobId(),
                id: 'iframe_FINDINGS',
                frameborder: 0,
                style: 'display: block; width: 100%; height: 1500px; margin-left: 0px;',
            }).appendTo('#divProcessReport');

            $('#ProcessReportPopUp').modal('show');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: NavigateToSSRSProcessReport() method in CustomWReport.js';
            logger.logMessage(msg);
        }
    }

    function DownloadArchiveReport(data, event) {
        try {
            var payLoad = {
                t: appsecurity.getAuthenticationInfo(), FullFilePath: data.Archive_file()
            };
            utils.postAndRedirect(rootPath + "/FileDownload/QuantitativeArchiveDocument", payLoad, '_blank');
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | DownloadArchiveReport() in CustomWReport.js';
            logger.logMessage(msg);
        }
    }

    function DownloadErrorReport(data, event) {
        try {
            var payLoad = {
                t: appsecurity.getAuthenticationInfo(), FullFilePath: data.Error_File()
            };
            utils.postAndRedirect(rootPath + "/FileDownload/QuantitativeErrorDocument", payLoad, '_blank');
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | DownloadErrorReport() in CustomWReport.js';
            logger.logMessage(msg);
        }
    }

    //model definition starts here
    function Doctypes(item) {
        try {
            var self = this;
            self.DocType = ko.observable($('<div/>').html(item.Doctype).text());
            self.DocCode = ko.observable($('<div/>').html(item.Type).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Doctypes() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function ReportDetailsModel(item) {
        try {
            var self = this;
            CRmViewModel.SrNo(CRmViewModel.SrNo() + 1);
            self.SrNo = ko.observable(CRmViewModel.SrNo());
            self.DocId = ko.observable($('<div/>').html(item.DocumentId).text());
            self.DocComments = ko.observable($('<div/>').html(item.DocumentComments).text());
            self.DocumentName = ko.observable($('<div/>').html(item.DocumentName).text());
            self.DocumentUploadedforProfile = ko.observable($('<div/>').html(item.DocumentUploadedforProfile).text());
            self.DocType = ko.observable($('<div/>').html(item.DocumentType).text());
            self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text())
            self.UserName = ko.observable($('<div/>').html(item.UserName).text());
            self.DocPath = ko.observable($('<div/>').html(item.DocumentPath).text());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ReportDetailsModel() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function WordReportDetailsModel(item) {
        try {
            var self = this;
            CRmViewModel.SrNo(CRmViewModel.SrNo() + 1);
            self.SrNo = ko.observable(CRmViewModel.SrNo());
            self.JobId = ko.observable($('<div/>').html(item.JobId).text());
            self.JobStatus = ko.observable($('<div/>').html(item.JobStatus).text());
            self.DataProcessStatus = ko.observable($('<div/>').html(item.DataProcessStatus).text());
            self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text());
            self.DataProcessFlag = ko.observable($('<div/>').html(item.DataProcessFlag).text());
            self.UploadedBy = ko.observable($('<div/>').html(item.UploadedBy).text());
            self.DocPath = ko.observable($('<div/>').html(item.DocumentPath).text());
            self.Archive_file = ko.observable($('<div/>').html(item.Archive_file).text());
            self.Error_File = ko.observable($('<div/>').html(item.Error_File).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ReportDetailsModel() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }



    //Model to Store the Profileofassessmentdetails
    function ProfileofAssessmentModel(item) {
        try {
            var self = this;
            self.ConfigurationFreezeFlag = ko.observable('true');
            self.Fromdate = ko.observable($('<div/>').html(item.Fromdate).text());
            self.Todate = ko.observable($('<div/>').html(item.Todate).text());
            self.ProfileId = ko.observable($('<div/>').html(item.ProfileId).text());
            self.Profilename = ko.observable($('<div/>').html(item.Profilename).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ProfileofAssessmentModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    //------------------------------------------------------------------------Logic to Fetch User Details and List of All Roles Starts Here----------------------------------------------




    //------------------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------------

});
